import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import ServiceBanner from "../Components/ServiceBanner";
import Footer from "../Components/Footer";
import ServiceBar from "../Components/ServiceBar";
import customBanner from "../Images/auto.jpg";

export default function About() {
  return (
    <>
      <div className="fadeIn animated">
        <ServiceBanner
          customImage={customBanner}
        />

        <Row className="no-gutters mt-4 ">
          <Container>
            <Row>
              <Col sm={12} className="text-center ">
              <h3>INDUSTRIAL ROBOTICS</h3>
                <blockquote className="mt-4 font-italic">
                  <sup>
                    <i className="fa fa-quote-left" aria-hidden="true"></i>
                  </sup>{" "}
                 We design and deploy custom robotic systems that support automation in assembly lines, material handling, inspection, and packaging. Our robots are equipped with intelligent control systems, machine vision, and adaptive algorithms, enabling safe and efficient human-robot collaboration. We help industries achieve higher productivity, improved quality, and reduced labor costs through fully or semi-automated robotic solutions.{" "}
                  <sup>
                    <i className="fa fa-quote-right" aria-hidden="true"></i>
                  </sup>
                </blockquote>
              </Col>
            </Row>
          </Container>
        </Row>

       <section className="py-5 bg-light">
  <Container>
    <Row className="text-center">
      {/* Feature 1 */}
      <Col md={3} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp">
        <i className="bi bi-robot fa-3x mb-3 text-danger"></i>
        <hr className="my-3" />
        <h5>Robotic Arms</h5>
        <div className="btSubTitle small">
         Our advanced robotic arm solutions are designed for precision, flexibility, and reliability in modern industrial environments. 
Engineered with sensor integration, and real-time feedback systems, they perform tasks like material handling with high efficiency.

        </div>
        <hr className="my-3" />
      </Col>

      {/* Feature 2 */}
      <Col md={3} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-1s">
        <i className="bi bi-noise-reduction fa-3x mb-3 text-success"></i>
        <hr className="my-3" />
        <h5>Sensors & Machine Vision </h5>
        <div className="btSubTitle small">
         We integrate advanced sensor technologies and machine vision systems to enable intelligent perception and decision-making in automated environments.
AI-powered vision algorithms and other industry based sensor integration provide accurate detection, inspection, and quality assurance.

        </div>
        <hr className="mt-4" />
      </Col>

      {/* Feature 3 */}
      <Col md={3} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-2s">
        <i className="bi bi-journal-richtext fa-3x mb-3 text-info"></i>
        <hr className="my-3" />
        <h5>Programming Interfaces </h5>
        <div className="btSubTitle small">
         We leverage industry-standard platforms and programming languages such as ROS (Robot Operating System), Python, and proprietary SDKs to develop, control, and optimize robotic systems. 
These interfaces enable high-level automation, sensor fusion, path planning, and real-time data processing, ensuring flexible and scalable robotic deployments.

        </div>
        <hr className="mt-4" />
      </Col>
      <Col md={3} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-2s">
        <i className="bi bi-asterisk fa-3x mb-3 text-warning"></i>
        <hr className="my-3" />
        <h5>Autonomous Navigation (AGVs/AMRs) </h5>
        <div className="btSubTitle small">
         Our autonomous navigation solutions empower Automated Guided Vehicles (AGVs) and Autonomous Mobile Robots (AMRs) to operate seamlessly in dynamic industrial and logistics environments. 
        </div>
        <hr className="mt-4" />
      </Col>
    </Row>
  </Container>
</section>


        <ServiceBar />
        <Footer />
      </div>
    </>
  );
}
